import { APP_LINKS } from '@/helpers/links';
import { MyLink } from '@/components/MyLink';
import { ActiveList } from './components/ActiveList';
import { ReleasedList } from './components/ReleasedList';
import s from './index.module.scss';

const PersonalGuaranteePage = () => {
  return (
    <div className={s.page}>
      <div className="container-inner">
        <div className={s.content}>
          <MyLink className={s.learn} href={APP_LINKS.loanTermsFpg()}>
            Learn more →
          </MyLink>
          <ActiveList />
          <ReleasedList />
        </div>
      </div>
    </div>
  );
};

export default PersonalGuaranteePage;
